import api from "../request";
import { Promise } from "q";

function getMessages(reqData) {
  return api
    .post(`messages/all/${reqData.type}`, { reqData })
    .then(({ data }) => {
      return data;
    });
  //return api.get(`messages/all/${reqData.type}?page=${reqData.page}&pageSize=${reqData.pageSize}&q=${reqData.q}&orderByField=${reqData.orderBy.field}&orderByOrder=${reqData.orderBy.order}`)
}
function sendMessage(reqData) {
  return api.post(`messages/send`, { reqData }).then(({ data }) => {
    return data;
  });
}
function broadcastMessage(reqData) {
  return api
    .post(`messages/send-by-batch-or-center`, { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getUserIdList(reqData) {
  return api.get(`/users/username/search?q=${reqData.q}`);
}
function deleteMessage(reqData) {
  return api.delete(`/messages/${reqData.id}`);
}
function updateNotificationReadStatus(reqData) {
  return api.get(`/messages/get/${reqData.id}`).then(({ data }) => {
    return data;
  });
}
export default {
  getMessages,
  sendMessage,
  broadcastMessage,
  getUserIdList,
  deleteMessage,
  updateNotificationReadStatus,
};
